import React, { useEffect, useState, createContext, useContext } from 'react';
import { Language, Translations, getTranslation } from '../utils/translations';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: Translations;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Default to Portuguese
  const [language, setLanguageState] = useState<Language>('pt');
  const [t, setT] = useState<Translations>(getTranslation('pt'));
  useEffect(() => {
    // Load language from localStorage or default to Portuguese
    const savedLanguage = localStorage.getItem('kredita-language') as Language;
    if (savedLanguage && (savedLanguage === 'en' || savedLanguage === 'pt')) {
      setLanguageState(savedLanguage);
      setT(getTranslation(savedLanguage));
    }
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    setT(getTranslation(lang));
    localStorage.setItem('kredita-language', lang);
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t
  }} data-id="element-374">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};